<template>
    <div>
        <div v-if="getannouncement">
            <v-card class="fill-height" elevation="0">
                <v-card-title>
                    <v-icon>mdi-eye</v-icon>&nbsp;Preview
                </v-card-title>
                <v-card-text>
                    <v-alert
                        dense
                        :type="mClass"
                        prominent
                    >
                        <div class="text-h6">{{ mTitle }}</div>
                        <div>{{ mText }}</div>
                    </v-alert>
                </v-card-text>
            </v-card>
            <v-card class="fill-height" elevation="0">
                <v-card-title>
                    <v-icon>mdi-pencil</v-icon>&nbsp;Set Announcement
                    <v-spacer></v-spacer>
                    <v-card-subtitle style="text-align:right;"><i>Announcement Last updated: {{ lastupdateddate }}</i></v-card-subtitle>
                </v-card-title>
                <v-card-text>
                    <v-form @submit="saveAnnouncement" target="hiddenFrame">
                        <v-row>
                            <v-col cols="2">
                                <v-subheader>
                                    Announcement Type
                                </v-subheader>
                            </v-col>
                            <v-col cols="10">
                                <v-select
                                    v-model="mClass"
                                    hint="Decides base color of the announcement box"
                                    :items="mClassList"
                                    persistent-hint
                                    outlined
                                    dense
                                    @change="validateForm"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2">
                                <v-subheader>
                                    Announcement Title
                                </v-subheader>
                            </v-col>
                            <v-col cols="10">
                                <v-text-field
                                    v-model="mTitle"
                                    hint="Sets title of the message"
                                    persistent-hint
                                    outlined
                                    dense
                                    @keyup="validateForm"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2">
                                <v-subheader>
                                    Announcement Text
                                </v-subheader>
                            </v-col>
                            <v-col cols="10">
                                <v-textarea
                                    outlined
                                    label="Sets the announcement text"
                                    v-model="mText"
                                    @keyup="validateForm"
                                    dense
                                    hint="This cannot be left blank"
                                    persistent-hint
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="2">
                                
                            </v-col>
                            <v-col cols="10">
                                <v-checkbox
                                    v-model="mDisplay"
                                    true-value="yes"
                                    false-value="no"
                                    label="Display announcement"
                                    dense
                                    @change="validateForm"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-btn
                            :disabled="!btnSubmitEnable"
                            color="success"
                            type="submit"
                            style="float: right;"
                            :loading="uploadloading"
                        >
                            Submit
                        </v-btn>
                        <br />
                    </v-form>
                </v-card-text>
            </v-card>
        </div>
        <div v-else>
            <v-row 
                class="fill-height"
                align-content="center"
                justify="center"
            >
                <v-container style="height: 400px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            Calling saved announcement...
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear
                                color="#80CBC4"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
        </div>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    data(){
        return {
            host: location.hostname.toString(),
            getannouncement: false,
            mClassList: [
                {text: "warning", value: "warning"},
                {text: "urgent", value: "error"}
            ],
            mClass: "warning",
            mTitle: "",
            mText: "",
            mDisplay: "",
            lastupdateddate: "",
            btnSubmitEnable: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            uploadloading: false
        }
    },
    methods: {
        getAnnouncement(){
            const that = this;
            that.getannouncement = false;

            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getannouncement';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (result) {
                    if(!result.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+result.message, "#EF6C00"); //orange
                    }else {
                        if(result.data.hasOwnProperty("urgent")){
                            let resultData = result.data.urgent;
                            var date = new Date();
                            if(resultData.hasOwnProperty("updatedTimestamp")){
                                date = new Date(parseFloat(resultData["updatedTimestamp"]));
                            }else {
                                date = new Date(parseFloat(resultData["createdTimestamp"]));
                            }
                            that.lastupdateddate = date.toDateString()+", "+String(date.getHours()).padStart(2, '0')+":"+String(date.getMinutes()).padStart(2, '0')+":"+String(date.getSeconds()).padStart(2, '0');
                            that.mClass = resultData["class"];
                            that.mTitle = resultData["title"];
                            that.mText = resultData["text"];
                            that.mDisplay = resultData["display"];
                        }
                    }

                    that.getannouncement = true;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        validateForm(){
            const that = this;

            if(that.mText == ""){
                that.btnSubmitEnable = false;
            }else {
                that.btnSubmitEnable = true;
            }
        },
        saveAnnouncement(){
            const that = this;

            that.uploadloading = true;
            
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';
            
            let announcement = {
                "class" : that.mClass,
                "title" : that.mTitle,
                "text" : that.mText,
                "display" : that.mDisplay
            };

            const formData = new FormData();

            formData.append("mode", "setannouncement");
            formData.append("data", JSON.stringify({"urgent": announcement}));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Announcement displayed!", "#388E3C"); //green
                    }

                    that.uploadloading = false;
                })
                .catch(function(err){
                    that.uploadloading = false;
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling

            that.btnSubmitEnable = false;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    }, 
    created(){
        const that = this;
        that.getAnnouncement();
    }
}
</script>